/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from "@emotion/styled";
import MainLayout from "@/components/Dashboard/Layout/MainLayout";
import {
  ListPageContainer,
  ListPageHeader,
  PageWashBackground,
} from "@/components/Dashboard/Layout/PageShell";
import { Dashboard } from "@/components/Dashboard/Dashboard/Dashboard";

const Canvas = styled("div")`
  background: ${({ theme }) => (theme as any).colors.canvas};
  min-height: 1300px;
`;

const DashboardPage = () => (
  <MainLayout>
    <Canvas>
      <PageWashBackground style={{ minHeight: 1080 }}>
        <ListPageContainer>
          <ListPageHeader>Dashboard</ListPageHeader>
          <Dashboard />
        </ListPageContainer>
      </PageWashBackground>
    </Canvas>
  </MainLayout>
);

export default DashboardPage;
